<template>
	<div>
		<div style="position: fixed; bottom: 1rem; left: 2rem;z-index:10000">
			<b-dropdown
				no-caret
				variant="dark"
			>
				<template #button-content>
					<span
						variant="dark"
					>
						<b-icon
							icon="list-ul"
							variant="secondary"
						/>
					</span>
				</template>
					
				<b-dropdown-item
					v-for="(tourStop, index) in activeTour.data.stops"
					:key="index"
					@click="selectStop(index)"
				>
					<span class="w-100 d-flex justify-content-between align-items-center">
						{{ tourStop.name }}
						<b-badge v-if="index === currentStop-1" variant="primary" pill>
							<b-icon-camera-video />
						</b-badge>
					</span>
				</b-dropdown-item>
			</b-dropdown>		
				
			<b-button
				variant="dark"
			>
				<b-icon
					icon="chevron-double-left"
					variant="secondary"
					@click="stopPrevious()"
				/>
			</b-button>
			<b-button variant="dark">
				{{ formatCurrentStop }}
			</b-button>
			<b-button
				variant="dark"
			>
				<b-icon
					icon="chevron-double-right"
					variant="secondary"
					@click="stopNext()"
				/>
			</b-button>
			<b-button
				variant="dark"
			>
				<b-icon
					icon="x"
					variant="secondary"
					@click="clearTour"
				/>
			</b-button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
	name: 'TourPlayback',
	data() {
		return {
			currentStop: null,
			totalStops: null,
		};
	},
	computed: {
		...mapGetters(['activeTour']),
		...mapState(['openPanels']),
		formatCurrentStop() {
			return `${this.currentStop} / ${this.totalStops}`;
		},
		getActiveTourCurrentStop() {
			return this.activeTour.data.activeStopIndex;
		},
	},
	watch: {
		getActiveTourCurrentStop(newStop, oldStop) {
			if (newStop !== oldStop) {
				this.updatePlaybackInterface();
			}
		},
	},
	created() {
		this.updatePlaybackInterface();
	},
	mounted() {
		this.updatePlaybackInterface();
	},
	methods: {
		...mapMutations(['setActiveTour', 'setActiveTourStop', 'setElementEditorEntityDataId']),
		updatePlaybackInterface() {
			this.currentStop = this.activeTour.data.activeStopIndex + 1 || '-';
			this.totalStops = this.activeTour.data.stops.length || '-';
		},
		selectStop(index) {
			this.updatePlaybackInterface();
			this.setActiveTourStop(index);
			if (this.activeTour.data.stops[index] && this.activeTour.data.stops[index].projectTools) {
				this.openPanels.projectTools = this.activeTour.data.stops[index].projectTools;
				if (
					this.activeTour.data.stops[index].projectTools.wide.tools.length >= 1 &&
					this.activeTour.data.stops[index].elementEditor
				) {
					for (const currentPanel of this.activeTour.data.stops[index].projectTools.wide.tools) {
						if (currentPanel.componentName === 'BuildingInputForm') {
							this.setElementEditorEntityDataId(this.activeTour.data.stops[index].elementEditor);
							break;
						}
					}
				}
			}
			this.$czm('flyToStop', this.activeTour.data.stops[index]);
		},
		stopNext() {
			let currentStop = this.activeTour.data.activeStopIndex + 1;
			if (currentStop === this.activeTour.data.stops.length) currentStop = 0;
			this.selectStop(currentStop);
		},
		stopPrevious() {
			let currentStop = this.activeTour.data.activeStopIndex - 1;
			if (currentStop < 0) currentStop = this.activeTour.data.stops.length - 1;
			this.selectStop(currentStop);
		},
		clearTour() {
			this.setActiveTour(-1);
		},
	},
};
</script>

<style scoped>
</style>
